import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const getAllOrganizations = (
  keywords,
  fetchUsers,
  orgType,
  limit,
  lastTime,
  version,
  callback,
  errorCallback,
) => {
  return async (dispatch) => {
    if (lastTime) {
      dispatch({
        type: 'GETTING_ALL_ORGANIZATIONS_WITH_PAGINATION',
      });
    } else {
      dispatch({ type: 'GETTING_ALL_ORGANIZATIONS' });
    }
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.post(`/ads/org/search`, keywords, {
            params: {
              'request-id': reqId,
              limit: limit,
              lastSeen: lastTime,
              orgType,
              fetchUsers,
              app:
                version === 'all' ? '' : version === 'v1' ? 'QAI-V1' : 'QAI-V2',
            },
            headers: {
              Authorization: `Bearer ${token}`,
              // 'x-api-version': 'v2',
            },
          });
          if (response.status === 200) {
            if (lastTime) {
              await dispatch({
                type: 'ADD_ORGANIZATIONS_TO_ALL_ORGANIZATIONS',
                payload: {
                  organizations: response?.data,
                  lastTime: response?.data?.[response?.data?.length - 1]?.id,
                },
              });
            } else {
              await dispatch({
                type: 'GETTING_ALL_ORGANIZATIONS_DONE',
                payload: {
                  organizations: response?.data,
                  lastTime: response?.data?.[response?.data?.length - 1]?.id,
                },
              });
            }
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'GETTING_ALL_ORGANIZATIONS_FAILED',
              payload: `Failed to fetch organizations`,
            });
            if (typeof errorCallback === 'function') {
              errorCallback(`Failed to fetch organizations`);
            }
          }
        } catch (e) {
          dispatch({
            type: 'GETTING_ALL_ORGANIZATIONS_FAILED',
            payload: `Failed to fetch organizations`,
          });
          if (typeof errorCallback === 'function') {
            errorCallback(`Failed to fetch organizations`);
          }
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'GETTING_ALL_ORGANIZATIONS_FAILED',
        payload: `Failed to fetch organizations`,
      });
      if (typeof errorCallback === 'function') {
        errorCallback(`Failed to fetch organizations`);
      }
    }
  };
};

export default getAllOrganizations;
